import { axios } from '@Root/API'

export const edit = (engagementId, payload) => {
	return axios.put(`student-engagement/${engagementId}/student-initiative/${payload.id}`, payload)
}
